import { useNeuroMessages } from "@ignitesales/neuro-application";
import { getProductButtonMessages } from "../utils/productHelper.mjs";

export const useProductButtonsMessages = (productId) => {
    const messageContext = useNeuroMessages();
    return getProductButtonMessages(messageContext, productId);
};

export default useProductButtonsMessages;
